import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScProfileInfoForm = styled.div`
  .form {
    display: flex;
    flex-direction: column;

    h3 {
      font-size: 12px;
      line-height: 18px;
    }
  }

  .rowGroup {
    width: 100%;
    display: flex;
    gap: 16px;

    & > * {
      flex: 1;
    }

    @media (${device.mobile}) {
      flex-direction: column;
      gap: 0px;
    }
  }

  .submitBtn {
    margin: 8px 0px;
    display: flex;
    justify-content: center;

    button {
      max-width: 280px;

      @media (${device.mobile}) {
        max-width: 100%;
      }
    }
  }
`;

export const ScSecurityMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: ${({ theme }) => theme.blackLightColor};
  }

  .message {
    margin-left: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    color: ${({ theme }) => theme.blackLightColor};
  }
`;
